// extracted by mini-css-extract-plugin
export default {"component":"qN1WI","h1":"BF4Yo","h2":"Y2db5","h3":"fDWKD","h4":"oPWqM","h5":"vwaQ8","adaptive":"bRxxu","styled":"uSbfp"};